import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "laptop",
  "use": "laptop-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"laptop\"><path d=\"M29 26V9a1 1 0 00-1-1H4a1 1 0 00-1 1v17H1a2 2 0 002 2h26a2 2 0 002-2zM5 26V10h22v16z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/laptop.svg
// module id = CcVr
// module chunks = 39 44